import type { CSSProperties } from "react";

export const isChessSquare = (value: string | null | undefined): value is ChessSquare =>
  typeof value === "string" && /^[a-h][1-8]$/.test(value);
export type ChessSquare = `${"a" | "b" | "c" | "d" | "e" | "f" | "g" | "h"}${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8}`;
export interface ChessArrow {
  startSquare: ChessSquare;
  endSquare: ChessSquare;
  color: string;
  label?: string;
  description?: string;
}
export type ChessSquareStyles = Partial<Record<ChessSquare, CSSProperties>>;

export const chessArrow = (
  startSquare: ChessSquare,
  endSquare: ChessSquare,
  color: string,
  explanation?: Pick<ChessArrow, "label" | "description">,
): ChessArrow => ({
  startSquare,
  endSquare,
  color,
  ...explanation,
});
